module.exports = __webpack_public_path__ + "static/media/ab5.c03a21bc.png";